var map = {
	"./black.svg": 1131,
	"./blue-belt.svg": 7711,
	"./blue-stripe-belt.svg": 5794,
	"./brown-belt.svg": 1701,
	"./brown-stripe-belt.svg": 808,
	"./circle.svg": 3095,
	"./green-belt.svg": 3547,
	"./green-stripe-belt.svg": 8021,
	"./orange-belt.svg": 9086,
	"./purple-belt.svg": 9598,
	"./star-empty.svg": 4310,
	"./star-full.svg": 2859,
	"./star-half.svg": 8559,
	"./star.svg": 3167,
	"./white-belt.svg": 7468,
	"./yellow-belt.svg": 7126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4176;